export const errorHandler = (err) => {
    let error = '';
    if (err.response?.data) {
        for (const k in err.response.data) {
            if (k === 'message') {
                error += err.response.data[k] + ', '
            } else {
                error += err.response.data[k][0] + ', '
            }
        }
        error = error.trim().slice(0, error.length - 2)
    }
    // If no error message was extracted, use a default message
    if (!error || error.trim() === '') {
        error = err.message || 'An error occurred. Please try again.';
    }
    return { type: 'failure', message : error,status:err?.response?.status}
}